import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private languageChangedSubject = new BehaviorSubject<string>('en');
  private currentLanguage = 'en';
  languageChanged$ = this.languageChangedSubject.asObservable();

  constructor(private translate: TranslateService, private http: HttpClient) {
    this.translate.setDefaultLang('en'); // Set the default language
  }

  getCurrentLanguage() {
    return this.currentLanguage;
  }

  setNavMenuLanguage(lang: string): void {
    this.currentLanguage = lang;
    this.translate.use(lang);
    this.languageChangedSubject.next(lang);
  }
}
